
import {
    Container,
    Header,
    Segment,
} from 'semantic-ui-react'

import { PATHS } from "../../paths";

import { gql, useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

import styles from './Organisations.module.css';

const GET_ORGANISATIONS = gql`
query Organisation {
    me {
        isAdminInWorkingOrganisation
        organisations {
            id
            name
            isSupportingOrganisation
        }
    }
}`;

const Organisations = () => {
    const navigate = useNavigate();
    const { loading, error, data } = useQuery(GET_ORGANISATIONS);

    useEffect(() => {
        if (data && data.me.organisations.length === 1) {
            if (data.me.isAdminInWorkingOrganisation) {
                navigate(PATHS.PEOPLE);
            } else if (data.me.organisations[0].isSupportingOrganisation) {
                navigate(PATHS.OVERVIEW);
            } else {
                navigate(PATHS.CLASSES);
            }
        }
    }, [data])

    // if loading for more than 5 seconds, redirect to logout
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (loading) {
                navigate(PATHS.LOGOUT);
            }
        }, 5000);
        return () => clearTimeout(timeout);
    }, [loading]);


    if (loading || error) {
        return (
            <>
                <Segment style={{
                    display: 'flex',
                    justifyContent: 'center',
                }} vertical>
                    <Container
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            paddingTop: '2em',
                        }}
                    >
                        <Header as='h1'>Loading</Header>
                        <div className={styles.loader}></div>
                    </Container>
                </Segment>
            </>
        )
    }


    // TODO: we need a way to select and organisation to update your working organisation
    return (
        <Segment style={{ padding: '2em 0em' }} vertical>
            <Container>
                <Header as='h1'>Organisations</Header>
                {data.me.organisations.map((o: any) => (
                    <>
                        {o.name}
                        <br />
                    </>
                ))}
            </Container>
        </Segment>
    )
}

export { Organisations }
